import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-apollo';

import { MeQuery } from '../../../../../graphql/queries/account';
import ACCOUNT_ROLES from '../../../../../constants/account-roles';
import { getAccountFirstLastNameFromString } from '../../../views/Account/AccountSetup/components/AccountSetupForm/helpers';

/**
 * Determines whether a SB account is considered complete or not.
 *
 * @returns {{
 *  loading: boolean,
 *  user: Object,
 *  isAccountSetupComplete: boolean,
 * }}
 */
const useShutterbugAccountComplete = () => {
  const authenticated = useSelector(({ auth }) => auth.authenticated);
  const { data: { me: user } = {}, loading } = useQuery(MeQuery, {
    skip: !authenticated,
  });
  const [isAccountSetupComplete, setIsAccountSetupComplete] = useState(false);

  useEffect(() => {
    if (!user) {
      // Nothing to do really.
      return;
    }

    const { firstName, lastName } = getAccountFirstLastNameFromString(
      user.name,
    );

    if (firstName && lastName) {
      setIsAccountSetupComplete(() => true);
    } else if (user.roles.includes(ACCOUNT_ROLES.SHUTTERBUG)) {
      setIsAccountSetupComplete(false);
    } else {
      setIsAccountSetupComplete(() => true);
    }
  }, [authenticated, loading, user?.name]);

  return {
    loading,
    user,
    isAccountSetupComplete,
  };
};

export default useShutterbugAccountComplete;
